module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('article', {
    attrs: {
      "id": "video"
    }
  }, [_c('heading', {
    attrs: {
      "text": _vm.video.title,
      "level": 2,
      "font": "oswald",
      "color": "yellow",
      "variant": "uppercase"
    }
  }), _vm._v(" "), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.video.code)
    }
  }), _vm._v(" "), (_vm.$loading) ? _c('loader') : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ae5e9f9c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/router-views/encyclopedia/Video.vue
// module id = 280
// module chunks = 0